.wui-menu-portal-overlay {
  --wui-internal-glass-shadow: var(--wui-shadow-panel, 0 3px 9px rgb(0 0 0 / 0.27));
  --wui-internal-duration-overlay-enter: var(--wui-duration-menu-enter, 140ms);
  --wui-internal-duration-overlay-exit: var(--wui-duration-menu-exit, 100ms);
  user-select: none;

  position: fixed;
  z-index: var(--wui-layer-menu, 100);

  overflow: hidden;

  box-sizing: border-box;
  min-width: var(--wui-overlay-min-width, 200px);
  max-width: 90vw;
  max-height: 80vh;
  border-radius: 20px;

  color: var(--wui-color-text, #1b1b1b);

  background-color: var(--wui-color-surface-overlay, rgb(246 246 246 / 0.82));

  & .wui-menu-scroll {
    overflow-y: auto;
    max-height: 80vh;
  }

  & .wui-menu-content {
    padding: 4px;
  }

  &.dropdown-overlay {
    & .wui-menu-scroll {
      max-height: 320px;
    }

    &[data-level]:not([data-level='0']) {
      z-index: var(--wui-layer-menu-nested, 110);
    }
  }

  &.context-submenu {
    z-index: var(--wui-layer-menu-nested, 110);
  }
}
